import React, { useState, useEffect } from 'react';
import './Feedback.css';

const API_URL = process.env.REACT_APP_API_URL || '';

function Feedback() {
  const [feedback, setFeedback] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [total, setTotal] = useState(0);

  const fetchFeedback = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/admin/feedback?page=${page}&limit=20`, {
        credentials: 'include'
      });
      const data = await res.json();
      if (data.success) {
        setFeedback(data.feedback);
        setTotalPages(data.pagination.totalPages);
        setTotal(data.pagination.total);
      }
    } catch (error) {
      console.error('Failed to fetch feedback:', error);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchFeedback();
  }, [page]);

  const handleDelete = async (id) => {
    if (!window.confirm('Удалить эту обратную связь?')) return;
    
    try {
      const res = await fetch(`${API_URL}/api/admin/feedback/${id}`, {
        method: 'DELETE',
        credentials: 'include'
      });
      if (res.ok) {
        fetchFeedback();
      }
    } catch (error) {
      console.error('Failed to delete feedback:', error);
    }
  };

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleString('ru-RU', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div className="feedback-page">
      <div className="feedback-header">
        <h1>Обратная связь</h1>
        <span className="feedback-count">Всего: {total}</span>
      </div>

      {loading ? (
        <div className="feedback-loading">Загрузка...</div>
      ) : feedback.length === 0 ? (
        <div className="feedback-empty">Нет обратной связи</div>
      ) : (
        <div className="feedback-list">
          {feedback.map(item => (
            <div key={item.id} className="feedback-item">
              <div className="feedback-item-header">
                <div className="feedback-user">
                  <span className="feedback-user-name">
                    {item.user_name || 'Гость'}
                  </span>
                  {item.user_id && (
                    <span className="feedback-user-id">ID: {item.user_id}</span>
                  )}
                </div>
                <div className="feedback-date">{formatDate(item.created_at)}</div>
              </div>
              <div className="feedback-message">{item.message}</div>
              <div className="feedback-actions">
                <button 
                  className="feedback-delete-btn"
                  onClick={() => handleDelete(item.id)}
                >
                  Удалить
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {totalPages > 1 && (
        <div className="feedback-pagination">
          <button 
            disabled={page === 1}
            onClick={() => setPage(p => p - 1)}
          >
            ← Назад
          </button>
          <span>Страница {page} из {totalPages}</span>
          <button 
            disabled={page === totalPages}
            onClick={() => setPage(p => p + 1)}
          >
            Вперёд →
          </button>
        </div>
      )}
    </div>
  );
}

export default Feedback;
